import { ChevronLeft, Lock, Eye, Shield, Trash2 } from 'lucide-react';
import { Link } from 'react-router';
import { PacienteBottomNav } from '@/app/components/paciente/PacienteBottomNav';

export function PrivacidadPaciente() {
  return (
    <div className="min-h-screen bg-background transition-colors duration-200">
      <div className="w-full max-w-[480px] mx-auto p-6 pb-24 space-y-6">
        <div className="flex items-center gap-4">
          <Link to="/perfil" className="transition-all duration-200 ease-out hover:opacity-70">
            <ChevronLeft className="w-6 h-6" strokeWidth={1.5} />
          </Link>
          <h1 className="text-2xl">Privacidad y seguridad</h1>
        </div>

        <div className="space-y-3">
          <button className="w-full bg-card rounded-2xl p-4 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)] flex items-center justify-between transition-all duration-200 ease-out hover:bg-muted/30">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                <Lock className="w-5 h-5 text-primary" strokeWidth={1.5} />
              </div>
              <div className="text-left">
                <p className="font-medium">Cambiar contraseña</p>
                <p className="text-xs text-muted-foreground">Última actualización hace 3 meses</p>
              </div>
            </div>
          </button>

          <button className="w-full bg-card rounded-2xl p-4 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)] flex items-center justify-between transition-all duration-200 ease-out hover:bg-muted/30">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                <Eye className="w-5 h-5 text-primary" strokeWidth={1.5} />
              </div>
              <span className="font-medium">¿Quién puede ver mi progreso?</span>
            </div>
          </button>

          <button className="w-full bg-card rounded-2xl p-4 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)] flex items-center justify-between transition-all duration-200 ease-out hover:bg-muted/30">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                <Shield className="w-5 h-5 text-primary" strokeWidth={1.5} />
              </div>
              <div className="text-left">
                <p className="font-medium">Uso de datos de salud</p>
                <p className="text-xs text-muted-foreground">Cómo usamos tu información</p>
              </div>
            </div>
          </button>

          <button className="w-full bg-card rounded-2xl p-4 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)] flex items-center justify-between transition-all duration-200 ease-out hover:bg-muted/30">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                <Shield className="w-5 h-5 text-primary" strokeWidth={1.5} />
              </div>
              <span className="font-medium">Descargar mis datos</span>
            </div>
          </button>
        </div>

        <div className="bg-destructive/10 rounded-2xl p-5 border border-destructive/20 mt-8">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-10 h-10 bg-destructive/10 rounded-xl flex items-center justify-center flex-shrink-0">
              <Trash2 className="w-5 h-5 text-destructive" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-semibold text-destructive mb-1">Eliminar mi cuenta</h3>
              <p className="text-sm text-muted-foreground">
                Esta acción es permanente y eliminará todos tus datos de forma irreversible
              </p>
            </div>
          </div>
          <button className="w-full bg-destructive text-destructive-foreground py-3 rounded-full font-semibold transition-all duration-200 ease-out hover:opacity-90">
            Eliminar cuenta
          </button>
        </div>
      </div>

      <PacienteBottomNav />
    </div>
  );
}
